<template>

  <ion-page id="enginemenu-page">
    <ion-content>
  <div v-if="showState == SHOW_EXPLAINTOUR">
      <ExplainTour :screen="explainTourScreen"
                      :wordsSpoken="explainTourWordsSpoken"
                      :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                    @toolbar-click="explainTourToolbarClick" />
  </div>

  <div v-show="showState == SHOW_GAME">
    <TopLine :style="styleTopline" :title="topLineTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

    <div :style="styleMiddle">

      <div :style="styleBoard">
        <CMChessboard :fen="fen" :orientation="orientation"
                :boardSize="boardSize" @board-move="boardMove" />
      </div>
    
      <div id="game-movelist-container" :style="styleMoveList">
        <div v-if="moveList.length == 0">
          <p>Loading Game Review</p>
        </div>
        <div v-for="item in moveList" v-bind:key="item.index">
          <div :id="item.moveId" class="movelist-row">

            <div class="movelist-number">{{ item.index+1 }} </div>

            <div @click="onClick('white',item.index)" class="movelist-text" :class="{
                    'reptree-selected-text-dark' : (item.whiteSelected) && isDark,
                    'reptree-move-text-dark'     : (!(item.whiteSelected)) && isDark,
                    'reptree-selected-text-light' : (item.whiteSelected) && !isDark,
                    'reptree-move-text-light'     : (!(item.whiteSelected)) && !isDark
                  }">
            {{ item.whiteSan }}</div>
            <div @click="onClick('black',item.index)" class="movelist-text" :class="{
                    'reptree-selected-text-dark' : (item.blackSelected) && isDark,
                    'reptree-move-text-dark'     : (!(item.blackSelected)) && isDark,
                    'reptree-selected-text-light' : (item.blackSelected) && !isDark,
                    'reptree-move-text-light'     : (!(item.blackSelected)) && !isDark
                  }">
            {{ item.blackSan }}</div>

            <div class="movelist-text">{{ item.whiteScore }}</div>
            <div class="movelist-text">{{ item.blackScore }}</div>
          </div>
          <hr>
        </div>
      </div>
    </div>
    <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </div>

  </ion-content>
  </ion-page>
  

</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';

  import CMChessboard from '@/components/CMChessboard.vue'

  import { computed } from "@vue/reactivity"

  import { ref, watch } from 'vue'
  import ExplainTour from '@/components/ExplainTour.vue'
  import ToolBar from '@/components/ToolBar.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import TopLine from '@/components/TopLine.vue'
  import { useGetData, generateErrorAlertText } from '../../composables/getData.js'
  import { parseWordsSaid , buildWordListFromChoiceList, parseNumberWords } from '@/composables/wordlistSupport.js'

  import { buildStyleToolbar, buildStyleTopline, availableWidthHeight, scrollElement, buildStyleMiddle,
              calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import { useWindowSizeStore } from '../../stores/windowSizeStore';
  import { translateEnglishWords, translatePhrase } from '@/composables/translation';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  
  const gameIdWithWhoSent =  connectionStore.getReviewGameId
  const gameIdArray = gameIdWithWhoSent.split(",")
  const gameId = gameIdArray[0]
  const whoSent = gameIdArray[1]

  //console.log("game id ",gameId,whoSent)
  const isDark = ref(connectionStore.getDarkmode != "light")

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)
  const topLineTitle = ref(translatePhrase("Game Review"))


  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")
  const explainTourWordsSpokenTrigger = ref(0)

  const wordlistReview = "command scroll up down move first next back last explain done ignore mute listen one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen twenty thirty forty fifty sixty seventy eighty ninety";
  const wordlist = ref(wordlistReview)
  emit("word-list",wordlist.value)

  const wordlistTrigger = ref(0)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  
  //console.log("**** explorer initial screensize", windowSizeRef.value)

  const SHOW_GAME = 0
  const SHOW_EXPLAINTOUR = 1
  const showState = ref(SHOW_GAME)

  const TOOLBAR_FIRST = 0
  const TOOLBAR_BACK = 1
  const TOOLBAR_NEXT = 2
  const TOOLBAR_LAST = 3
  const TOOLBAR_EXPLAIN = 4

  const toolbarElements = ref([
    { index : TOOLBAR_FIRST, label : translateEnglishWords("First") ,disabled : true},
    { index : TOOLBAR_BACK, label : translateEnglishWords("Back") ,disabled : true},
    { index : TOOLBAR_NEXT, label : translateEnglishWords("Next") ,disabled : false},
    { index : TOOLBAR_LAST, label : translateEnglishWords("Last") ,disabled : false},
    { index : TOOLBAR_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false},
  ])

  const toolbarTrigger = ref(0)

  var blankAppendTrigger = " "
  const orientation = ref("white")
  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  const fen = ref(INITIAL_FEN)

  const boardSize = ref(300)

  var movelistHeight = 0
  var scrollTop = 0

  var moveCount = 0
  var plyCount = 0
  const moveList = ref([])

  var selectedMoveIndex = -1
  var selectedMoveColor = ""

  const styleMoveList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    cursor : "pointer"
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  function afterStartupCallbackRoutine(stuffChanged) {
    updateWidthHeights()
    getGame(gameId)
  }

  doStartupCheck(false,afterStartupCallbackRoutine)

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boardSize.value + "px"
    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"

    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleMoveList.value.height = boundaries['movelist'].height + "px"
    styleMoveList.value.width = boundaries['movelist'].width + "px"
    styleMoveList.value.top = boundaries['movelist'].top + "px"
    styleMoveList.value.left = boundaries['movelist'].left + "px"

    //console.log("**** boardsize ",boardSize.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)

    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())

    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
   
  }

  function calculatePortraitWidthHeights(availableSpace) {
    //console.log("available space ",availableSpace)

    const spaceForHeight = availableSpace.height *.75
    // reserve space for the instruction lines
    const availableSpaceForBoard = { width : availableSpace.width - availableSpace.leftIndent,
              height : spaceForHeight - availableSpace.topIndent - 56,
              isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const movelistPositionTop = boardPositionTop + boardHeight
    const movelistPositionLeft = availableSpace.leftRightIndent
    movelistHeight = availableSpace.height - movelistPositionTop
    const movelistWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft ,
        top : boardPositionTop
      },
      movelist : {
        width : movelistWidth,
        height : movelistHeight,
        left : movelistPositionLeft,
        top : movelistPositionTop 
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    //console.log("available space ",availableSpace)

     const spaceForWidth = availableSpace.width *.75
    // reserve space for the instruction lines
    const availableSpaceForBoard = { width : spaceForWidth,
              height : availableSpace.height - availableSpace.topIndent - 56,
              isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const movelistPositionTop = boardPositionTop
    const movelistPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    movelistHeight = availableSpace.height
    const movelistWidth = availableSpace.width - movelistPositionLeft

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft,
        top : boardPositionTop
      },
      movelist : {
        width : movelistWidth,
        height : movelistHeight,
        left : movelistPositionLeft,
        top : movelistPositionTop
      }
    }
    return (result)
  }

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })
   
  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
  })
  
  function boardMove(arrayIndex,from,to) {
  }

  function onClick(color,index) {
    var newFen = ""

    if (index == -1)
      fen.value = INITIAL_FEN
    else {
      if (color == "white")
        newFen = moveList.value[index].whiteFen 
      else
        newFen = moveList.value[index].blackFen
      if (newFen != undefined && newFen != "")
        fen.value = newFen
    }
    // remove any selected
    for (var i=0; i < moveList.value.length; i++) {
      moveList.value[i].whiteSelected = false
      moveList.value[i].blackSelected = false
    }

    if (index >= 0) {
      if (color == "white")
        moveList.value[index].whiteSelected = true
      else
        moveList.value[index].blackSelected = true
    }
    selectedMoveColor = color
    selectedMoveIndex = index

    toolbarElements.value[TOOLBAR_FIRST].disabled = (selectedMoveColor == "" &&  selectedMoveIndex == -1)
    toolbarElements.value[TOOLBAR_BACK].disabled = toolbarElements.value[TOOLBAR_FIRST].disabled

    var atLastMove = false
    if (selectedMoveIndex == moveList.value.length - 1)
      if (moveList.value[index].blackFen == undefined || moveList.value[index].blackFen == "")
        atLastMove = true
      else
        if (selectedMoveColor == "black")
          atLastMove = true
    
    toolbarElements.value[TOOLBAR_LAST].disabled = atLastMove
    toolbarElements.value[TOOLBAR_NEXT].disabled = toolbarElements.value[TOOLBAR_LAST].disabled
    toolbarTrigger.value++

    const id = (color == "" || index < 0) ? 0 : index
    const moveElement = document.getElementById("move" + id)
    //console.log("move Element",moveElement)
    if (moveElement != null)
      moveElement.scrollIntoView()
  }

  // START Explain Tour Routines

  function explainTourInitialize(errorText) {
    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value = (errorText == null) ? "game_review" : ("ERROR:" + errorText);
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
  }

  function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {

      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_GAME
        wordlist.value = wordlistReview
        emit("word-list",wordlist.value)

        wordlistTrigger.value++
        break
  }
}


  // END Explain Tour Routines

  function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function toolbarClick(arrayIndex) {
    //console.log("toolbarclick ",arrayIndex)
    switch (arrayIndex) {
      case TOOLBAR_FIRST :
        processWords("command first")
        break
      case TOOLBAR_BACK :
        processWords("command back")
        break
      case TOOLBAR_NEXT :
        processWords("command next")
        break
      case TOOLBAR_LAST :
        processWords("command last")
        break
      case TOOLBAR_EXPLAIN :
        processWords("command explain")
        break
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "explain" || currentWord == "mute" || currentWord == "listen") {
            return [currentWord,""]
        }
        if (currentWord == "done") {
            return ["done",""]
        }
        if (currentWord == "scroll") {
            if (nextWord == "up") {
                return ["scroll", "up"]
            }
            if (nextWord == "down") {
                return ["scroll", "down"]
            }
        }
        
        if (currentWord == "move") {
          const moveIndex = parseNumberWords(nextWord,nextNextWord)
          return ["move", moveIndex]
        }
        // add choices here
        if (currentWord == "next")
          return ["next",""]
        if (currentWord == "back")
          return ["back",""]
        if (currentWord == "first")
          return ["first",""]
        if (currentWord == "last")
          return ["last",""]

        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

  function processWords(text) {
    //console.log("text in engine Menu ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    if (showState.value == SHOW_EXPLAINTOUR) {
      //console.log("*** words for explain tour",text)
      explainTourWordsSpoken.value = text
      explainTourWordsSpokenTrigger.value++
      return;
    }
    switch (returnArray[0]) {
      case "scroll" :
        scrollElement("game-movelist-container",returnArray[1])
        break
      case "first" :
        if (toolbarElements.value[TOOLBAR_FIRST].disabled == true)
          break
        onClick("",-1)
        break
      case "back" :
        if (toolbarElements.value[TOOLBAR_BACK].disabled == true)
          break
        if (selectedMoveColor == "black")
          onClick("white",selectedMoveIndex)
        else
          if (selectedMoveIndex == 0)
            onClick("",-1)
          else
            onClick("black",selectedMoveIndex - 1)
        break
      case "next" :
        if (toolbarElements.value[TOOLBAR_NEXT].disabled == true)
          break
        if (selectedMoveIndex == -1)
          onClick("white",0)
        else
          if (selectedMoveColor == "white")
            onClick("black",selectedMoveIndex)
          else
            onClick("white",selectedMoveIndex + 1)
        break
      case "last" :
        if (toolbarElements.value[TOOLBAR_LAST].disabled == true)
          break
        const lastMoveColor = (moveList.value[moveList.value.length - 1].blackFen != undefined &&
                  moveList.value[moveList.value.length - 1].blackFen != "") ? "black" : "white"
        onClick(lastMoveColor,moveList.value.length - 1)
        break
      case "move" :
        const moveIndex = returnArray[1] - 1
        if (moveIndex < 0)
          break
        if (moveIndex > moveList.value.length -1)
          break
        onClick("white",moveIndex)
        break
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize(null)
        break
      case "done" :
        emit("where-next",whoSent)
        //router.replace({ path: whoSent})
        break
    }
  }

  function processJsonResponse (json) {
    //console.log(" in game review callback",json)
    if (json.hasOwnProperty('error')) {
      explainTourInitialize(generateErrorAlertText(json))
      return;
    }

    moveCount = Math.floor(json["move_count"])

    const whiteString = Math.floor(json["white"])
    orientation.value = (whiteString == 1) ? "white" : "black"

    const fens = json["fens"].split(",")
    const froms = json["froms"].split(",")
    const tos = json["tos"].split(",")
    const sans = json["sans"].split(",")
    const promotes = json["promotes"].split(",")
    const scores = json["scores"].split(",")

    plyCount = sans.length
    if (plyCount > 0 && sans[plyCount-1] == "")
        plyCount -= 1
        
    moveList.value = []
 
    for (var i = 0; i < moveCount; i++) {
      const plyNumber = i * 2
      const oneMove = {
        index : i,
        moveId : "move" + i,
        whiteFen : fens[plyNumber],
        blackFen : fens[plyNumber + 1],
        whiteSan : sans[plyNumber],
        blackSan : sans[plyNumber + 1],
        whiteSelected : false,
        blackSelected : false,
        whiteScore : scores[plyNumber],
        blackScore : scores[plyNumber + 1]
      }
      moveList.value.push(oneMove)
    }
    
    //console.log("Move List ",moveList.value)
    fen.value = INITIAL_FEN
  }
  
  function getGame(gameId) {
    var formData = {
      id : gameId
    }
    //console.log("get game formdata",formData)
    useGetData("get39_blind_game.php", formData, processJsonResponse)
  }

</script>

<style scoped>

.movelist-row {
  height : 12px;
}

.movelist-number {
  display: inline-block;
  width : 8%;
  position : relative;
}

.movelist-text {
  display: inline-block;
  width : 20%;
  margin-right : 3%;
  position : relative;
  padding: 2px;
}

.reptree-move-text-light {
  color : rgb(13,110,253)
}
.reptree-move-text-dark {
  color : #fff;
}
.reptree-selected-text-light {
  color : blue;
  background : yellow;
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

</style>

